import { render, staticRenderFns } from "./HighlightPreview.vue?vue&type=template&id=8e97c80e&scoped=true&"
import script from "./HighlightPreview.vue?vue&type=script&lang=js&"
export * from "./HighlightPreview.vue?vue&type=script&lang=js&"
import style0 from "./HighlightPreview.vue?vue&type=style&index=0&id=8e97c80e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e97c80e",
  null
  
)

export default component.exports